<template>
  <div>
    <div class="form-group">
      <div class="form-label">
        <label
          class="control-label">カード番号<span class="req">＊</span></label>
      </div>
      <div class="form-item">
        <div class="form-item-card">
          <div class="form-item-text">取り扱いカード</div>
          <img
            src="/img/common/card.png"
            alt="取り扱いカード">
        </div>
        <input
          v-model="card_info.card_number"
          v-cardformat:formatCardNumber
          class="form-control"
          type="text"
          name="card_number"
          autocomplete="cc-number"
          @blur="checkNumber('card_number')">
        <p
          v-if="errors.card_number"
          class="form-caution-text">
          {{ errors.card_number }}
        </p>
      </div>
    </div>
    <div class="form-group">
      <div class="form-label">
        <label
          class="control-label">有効期限（月/年）<span class="req">＊</span></label>
      </div>
      <div class="form-item">
        <input
          id="cardExpire1"
          v-model="card_info.card_expiry1"
          class="form-control form-control--card1"
          type="text"
          name="card_expiry"
          maxlength="2"
          autocomplete="cc-exp"
          @blur="checkNumber('card_expiry')">
        <input
          id="cardExpire2"
          v-model="card_info.card_expiry2"
          class="form-control form-control--card2"
          type="text"
          name="card_expiry"
          maxlength="2"
          autocomplete="cc-exp"
          @blur="checkNumber('card_expiry')">
        <p
          v-if="errors.card_expiry"
          class="form-caution-text">
          {{ errors.card_expiry }}
        </p>
      </div>
    </div>
    <div class="form-group">
      <div class="form-label">
        <label
          class="control-label">カード名義<span class="req">＊</span></label>
      </div>
      <div class="form-item">
        <input
          v-model="card_info.card_name"
          class="form-control"
          type="text"
          name="card_name"
          @blur="checkNumber('card_name')">
        <p
          v-if="errors.card_name"
          class="form-caution-text">
          {{ errors.card_name }}
        </p>
      </div>
    </div>
    <div class="form-group">
      <div class="form-label">
        <label
          v-tooltip="spTooltipConfig(tooltipMessages.security_code)"
          class="control-label"
          for="security_code">セキュリティコード
          <span class="req">＊</span>
          <i
            v-tooltip="pcTooltipConfig(tooltipMessages.security_code)"
            class="tooltip-icon">
          </i>
          <i
            v-tooltip="spTooltipConfig(tooltipMessages.security_code)"
            class="sp-tooltip-icon">
          </i>
        </label>
      </div>
      <div class="form-item">
        <input
          id="security_code"
          v-model="card_info.security_code"
          v-cardformat:formatCardCVC
          class="form-control form-control--card-security"
          type="text"
          name=""
          maxlength="4"
          @blur="checkNumber('security_code')">
        <p
          v-if="errors.security_code"
          class="form-caution-text">
          {{ errors.security_code }}
        </p>
      </div>
    </div>
    <p
      v-if="showDebitCardText"
      class="debitcard-text">
      デビットカードやプリペイドカードなど、原則即時にご利用代金を口座から引き落としするサービスをご利用のお客様の場合、
      一時的に月額料金110円がお引き落としされる場合がございます。<br>
      この引き落としは一時的なものであり、一定期間後にカード会社より返金されます。<br>
      カード会社から返金されるまで今しばらくお待ちください。<br>
      ※返金時期はカード会社により異なりますので、ご契約のカード会社にお問合せください。<br>
    </p>
  </div>
</template>
<script>
import Vue from 'vue'
import tooltip from '../../mixins/tooltip'
import tooltipMessages from './creditcard-tooltip'

let vTimer = null
export default {
  name: 'CreditCard',
  mixins: [
    tooltip,
  ],
  props: {
    tooltipMessages: {
      type: Object,
      default: () => tooltipMessages,
    },
    showDebitCardText: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      card_info: {
        card_number: '',
        card_name: '',
        security_code: '',
        card_expiry1: '',
        card_expiry2: '',
      },
      errors: {
        card_number: null,
        card_name: null,
        card_expiry: null,
        security_code: null,
      },
      $cardFormat: Vue.prototype.$cardFormat,
    }
  },
  watch: {
    card_info: {
      handler() {
        const validated = this.$cardFormat.validateCardNumber(this.card_info.card_number)
          && this.$cardFormat.validateCardExpiry(`${this.card_info.card_expiry1} / ${this.card_info.card_expiry2}`)
          && this.$cardFormat.validateCardCVC(this.card_info.security_code)
          && this.card_name !== ''
        this.$emit('update', {
          validated,
          card_info: {
            card_number: this.card_info.card_number.replace(/\s+/g, ''),
            card_expire: `${this.card_info.card_expiry1}/${this.card_info.card_expiry2}`,
            security_code: this.card_info.security_code,
            card_name: this.card_info.card_name,
          },
        })
      },
      deep: true,
    },
  },
  methods: {
    checkNumber(key) {
      if (vTimer) clearTimeout(vTimer)
      vTimer = setTimeout(() => {
        switch (key) {
          case 'card_number':
            this.errors.card_number = this.$cardFormat.validateCardNumber(this.card_info.card_number) ? null : '正しい番号を入力してください'
            break
          case 'card_expiry':
            this.errors.card_expiry = this.$cardFormat.validateCardExpiry(`${this.card_info.card_expiry1} / ${this.card_info.card_expiry2}`) ? null : '正しい期限を入力してください'
            break
          case 'security_code':
            this.errors.security_code = this.$cardFormat.validateCardCVC(this.card_info.security_code) ? null : '正しい数字を入力してください'
            break
          case 'card_name':
            this.errors.card_name = this.card_info.card_name !== '' ? null : 'カード名義を入力してください'
            break
          default:
            break
        }
      }, 500)
    },
  },
}
</script>
<style lang="scss" scoped>
  .debitcard-text{
      padding-bottom:15px;
  }
</style>
